export default __webpack_public_path__ + "static/media/time.6ab9a410.svg";